module.exports = __webpack_public_path__ + "static/media/04.2efa6894.png";